var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPromptRecommendedFeaturesTools = function SvgIconPromptRecommendedFeaturesTools(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4B4F58",
    stroke: "#4B4F58",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "m11.38 2.094-.258.77A1.97 1.97 0 0 1 9.87 4.12l-.778.259a.13.13 0 0 0 0 .25l.778.258a1.96 1.96 0 0 1 1.244 1.245l.258.78a.131.131 0 0 0 .248 0l.269-.77a1.97 1.97 0 0 1 1.243-1.245l.778-.259a.13.13 0 0 0 .066-.202.13.13 0 0 0-.066-.047l-.769-.269a1.96 1.96 0 0 1-1.252-1.255l-.259-.78a.132.132 0 0 0-.248.01"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 11.5,
    r: 2.5,
    stroke: "#4B4F58",
    strokeWidth: 1.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 2.5,
    stroke: "#4B4F58",
    strokeWidth: 1.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 2.5,
    stroke: "#4B4F58",
    strokeWidth: 1.3
  })));
};
export default SvgIconPromptRecommendedFeaturesTools;